<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  }
});
</script>

<template>
  <div v-if="data && data.length > 0" class="catalog__tags">
    <ul class="m-0 p-0 catalog__tags-items">
      <li
        v-for="(item, itemIndex) in data"
        :key="itemIndex"
        class="m-0 p-0 catalog__tags-item label">
        <CTagDetect
          v-if="item.url && item.url.length > 0"
          :to="item.url"
          class="m-0 p-0 catalog__tags-item-title"
        >
          <p class="m-0 p-0" v-html="item.title"></p>
        </CTagDetect>
        <p
          v-else
          class="m-0 p-0 catalog__tags-item-title"
          v-html="item.title"
        ></p>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.catalog__tags {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  text-align: left;
  @include media-breakpoint-up(md) {
    gap: 24px;
    padding: 24px 48px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 24);
    @include responsive-spacing(padding-top, 24);
    @include responsive-spacing(padding-bottom, 24);
    @include responsive-spacing(padding-right, 48);
    @include responsive-spacing(padding-left, 48);
  }
  &-items {
    list-style: none;
    @include media-breakpoint-up(sm) {
      -moz-column-count: 2;
      column-count: 2;
    }
    @include media-breakpoint-up(xl) {
      -moz-column-count: 3;
      column-count: 3;
    }
  }
  &-item {
    padding: 8px 0 0 0;
    position: relative;
    &:after {
      border-bottom: 1px dotted $divider;
      bottom: 3px;
      content: '';
      left: 0;
      position: absolute;
      width: 100%;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(border-bottom-width, 1);
        @include responsive-spacing(bottom, 3);
      }
    }
    @include media-breakpoint-up(md) {
      padding: 16px 0 0 0;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-top, 16);
    }
    &-title {
      background-color: $white;
      display: inline-block;
      padding-right: 4px;
      position: relative;
      z-index: 1;
      @include media-breakpoint-up(md) {
        padding-right: 8px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(padding-right, 8);
      }
    }
  }
}
</style>